import React from 'react';

const convertDropboxUrl = (url) => {
  if (!url || !url.includes('dropbox.com')) {
    return url;
  }
  return url.replace(
    'www.dropbox.com',
    'dl.dropboxusercontent.com'
  ).replace('?dl=0', '');
};

const getFileType = (url) => {
  if (!url) {
    return 'unknown';
  }
  const lowerUrl = url.toLowerCase();
  if (lowerUrl.match(/\.(jpg|jpeg|png|gif|bmp|webp|svg)($|\?)/)) {
    return 'image';
  }
  if (lowerUrl.includes('base64')) {
    if (lowerUrl.includes('image/')) {
      return 'image';
    }
  }

  return 'unknown';
};

const MessageDocument = ({ link }) => {
  const originalLink = link;
  const previewLink = convertDropboxUrl(originalLink);
  const fileType = getFileType(originalLink);

  if (fileType === 'image') {
    return (
      <img
        src={previewLink}
        alt="MMS"
        style={{
          maxWidth: '180px',
          maxHeight: '210px',
          borderRadius: 5,
          objectFit: 'contain'
        }}
      />
    );
  }

  return (
    <embed
      width="180"
      height="210"
      style={{
        overflow: 'hidden',
        opacity: (link || '').includes('.mp4') ? 0.8 : 0.6
      }}
      src={previewLink}
    />
  );
};

export default MessageDocument;
